export enum salesDespatchNoteStatuses {
  checked = 'CHECKED',
  emailed = 'EMAILED',
  invoiced = 'INVOICED',
  pending = 'PENDING',
  printed = 'PRINTED',
}
